import { Fragment } from "react";
import { CannonPlane } from "./CannonPlane";

//Cannon Physics object for inside box
export function CannonBox({
  size = [1, 1, 1],
  position = [0, 0, 0],
  openTop = false,
  debug = false,
  thickness = 0.01,
}) {
  const [x, y, z] = position;

  const planesPositioning = {
    left: {
      position: [x - size[0] / 2, y + size[1] / 2, z],
      rotation: [0, 0, -Math.PI / 2],
    },
    right: {
      position: [x + size[0] / 2, y + size[1] / 2, z],
      rotation: [0, 0, -Math.PI / 2],
    },
    front: {
      position: [x, y + size[1] / 2, z + size[2] / 2],
      rotation: [-Math.PI / 2, 0, 0],
    },
    back: {
      position: [x, y + size[1] / 2, z - size[2] / 2],
      rotation: [-Math.PI / 2, 0, 0],
    },
    bottom: { position: [x, y, z], rotation: [0, 0, 0] },
    top: { position: [x, y + size[1], z], rotation: [0, 0, 0] },
  };
  return (
    <group>
      {Object.keys(planesPositioning).map((key) => {
        if (key === "top" && openTop) return null;

        const { position, rotation } = planesPositioning[key];
        return (
          <Fragment key={key}>
            <CannonPlane
              size={[size[0], size[2]]}
              position={position}
              rotation={rotation}
              thickness={thickness}
            />
            {debug && (
              <mesh position={position} rotation={rotation}>
                <boxGeometry args={[size[0], thickness, size[2]]} />
                <meshStandardMaterial color="red" wireframe />
              </mesh>
            )}
          </Fragment>
        );
      })}

      {/* <CannonPlane size={[size[0], size[2]]} position={[x, y - 0.08, z]} />
      <CannonPlane
        size={[size[0], size[2]]}
        position={[x, y + size[1] / 2, z - size[2] / 2]}
        rotation={[-Math.PI / 2, 0, 0]}
      />
      <CannonPlane
        size={[size[0], size[2]]}
        position={[x + size[0] / 2, y + size[1] / 2, z]}
        rotation={[0, 0, -Math.PI / 2]}
      />
      <CannonPlane
        size={[size[0], size[2]]}
        position={[x - size[0] / 2, y + size[1] / 2, z]}
        rotation={[0, 0, -Math.PI / 2]}
      />
      {!openTop ? (
        <CannonPlane size={[size[0], size[2]]} position={[x, y + size[1], z]} />
      ) : null}
      {debug
        ? Object.values(planesPositioning).map(
            ({ position, rotation }, index) => (
              <mesh position={position} rotation={rotation} key={index}>
                <boxGeometry args={[size[0], 0.01, size[2]]} />
                <meshStandardMaterial color="red" wireframe />
              </mesh>
            )
          )
        : null} */}
    </group>
  );
}
